<div class="container">
    <div id="main">
        <div class="row">
            <div class="col-16">
                <div class="both-at-end">
                    <h1 class="long-heading">Scope of Sales Appointment Confirmation </h1>
                    <button class="button primary" [routerLink]="['/ssi/electronic-soa/viewsoa']">SOA History</button>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-16">
                <div id="ctl00_ContentPlaceHolder1_div2">
                    <p class="text-center">
                        <span id="ctl00_ContentPlaceHolder1_lblMsg">Record Saved Successfully.<br>SOA Link sent to beneficiary at <strong>{{BeneficaryEmail}}</strong></span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>



    



